import React from 'react';
import ChipEdit from 'ChipEdit';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import '../reset.css';

import Header from '../../components/header/';
import Navigation from '../../components/navigation/';
import Footer from '../../components/footer/';
import MechanismList from './mechanismList/';

class Layout extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const { header, navigation, mechanism, media, footer } = content;

        return (
            <div>
                <Header content={header} />
                <Navigation content={navigation} current={7} />
                <Chip id="40048" type="static" title="合作机构" groupName="合作机构首页" content={mechanism}>
                    <MechanismList />
                </Chip>
                <Chip id="40048" type="static" title="合作媒体" groupName="合作机构首页" content={media}>
                    <MechanismList />
                </Chip>
                <Footer content={footer} />
                <ChipEdit />
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
Layout.propTypes = { content: PropTypes.object };

/**
 * 定义组件默认属性
 * */
Layout.defaultProps = {};

export default Layout;
